import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import {
  AuthStore,
  LanguageStore,
  NotificationsStore,
  SettingsPreference,
  SettingsPreferenceOption,
  UnitsStore,
} from '@store';

import { GTMService } from '../../shared/services';
import { NotificationSettingsDialogComponent } from './notification-settings/notification-settings.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent implements OnInit {
  readonly settingsPreference = SettingsPreference;
  readonly settingsPreferenceOption = SettingsPreferenceOption;

  constructor(
    public authStore: AuthStore,
    public unitsStore: UnitsStore,
    public notificationsStore: NotificationsStore,
    public languageStore: LanguageStore,
    private gtmService: GTMService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.unitsStore.fetchTemperatureUnit();
    combineLatest([this.authStore.isMaintainer$, this.authStore.isDemo$])
      .pipe(
        take(1),
        filter(([isMaintainer, isDemo]) => isMaintainer || isDemo)
      )
      .subscribe(() => {
        this.notificationsStore.getMailSubscription();
      });
  }

  onEditRecipients(): Observable<boolean> {
    const notificationSettingsDialog = this.dialog.open(NotificationSettingsDialogComponent, {
      width: '480px',
      panelClass: 'notification-settings-dialog',
      data: {},
      disableClose: true,
    });

    return notificationSettingsDialog.afterClosed();
  }

  valueChangeHandler(
    event: {
      currentValue: string;
      newValue: string;
    },
    preference: SettingsPreference
  ): void {
    if (event.currentValue !== event.newValue) {
      this.unitsStore.setSettingsPreference(event.newValue as SettingsPreferenceOption, preference);

      if (preference === SettingsPreference.Notifications) {
        this.notificationsStore.setMailSubscription(
          event.newValue === SettingsPreferenceOption.On ? true : false
        );
      }

      this.trackSettingToggle(preference);
    }
  }

  private trackSettingToggle(setting: SettingsPreference): void {
    this.gtmService.track('onToggle', setting, 'settings');
  }
}
